import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InventoryHeatmapChart from "./InventoryHeatmapChart";

// Static data for inventory heatmap
const STATIC_INVENTORY_DATA = {
  PRBC: {
    "A+": 45,
    "A-": 12,
    "B+": 38,
    "B-": 8,
    "AB+": 15,
    "AB-": 3,
    "O+": 72,
    "O-": 25,
  },
  FFP: {
    "A+": 30,
    "A-": 18,
    "B+": 22,
    "B-": 5,
    "AB+": 28,
    "AB-": 10,
    "O+": 55,
    "O-": 20,
  },
  Platelets: {
    "A+": 15,
    "A-": 6,
    "B+": 12,
    "B-": 0,
    "AB+": 8,
    "AB-": 2,
    "O+": 35,
    "O-": 10,
  },
  Cryo: {
    "A+": 60,
    "A-": 25,
    "B+": 45,
    "B-": 18,
    "AB+": 32,
    "AB-": 12,
    "O+": 85,
    "O-": 40,
  },
};

const InventoryHeatmapWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={12} lg={12}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Inventory Heatmap (Units in Stock)")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <InventoryHeatmapChart data={STATIC_INVENTORY_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default InventoryHeatmapWrapper;
